// extracted by mini-css-extract-plugin
export default {"wrapper":"ChatSuggestions_wrapper__1YGtB","item":"ChatSuggestions_item__Mf-ez","bottom":"ChatSuggestions_bottom__MjHzG"};